import { AbstractControl, ValidatorFn } from '@angular/forms';

export function dateRangeValidator(): ValidatorFn {
  return (group: AbstractControl): { [key: string]: any } | null => {
    const start = group.get('startDate')?.value;
    const end = group.get('endDate')?.value;

    if (!start || !end) return null;
    const startDate = new Date(start);
    const endDate = new Date(end);
    if (startDate > endDate) {
      return { dateRangeInvalid: true, message: 'Start date must be before end date' };
    }
    // 1 year = 365 days (not accounting for leap years)
    const diffInDays = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
    if (diffInDays > 365) {
      return { dateRangeExceedsOneYear: true, message: 'Date range cannot exceed 1 year' };
    }
    return null;
  };
}
